import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { MailService } from '../mail/mail.service';
import { Mail } from '../mail/mail';

@Injectable({ providedIn: 'root'})
export class MailResolver implements Resolve<Observable<Mail[]>>{

    constructor(private service: MailService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Mail[]> {
        return this.service.findAll();
    }
}